import { render, staticRenderFns } from "./Tags.vue?vue&type=template&id=4b0ffe3d&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/eric/projects/musical/musical-admin-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b0ffe3d')) {
      api.createRecord('4b0ffe3d', component.options)
    } else {
      api.reload('4b0ffe3d', component.options)
    }
    module.hot.accept("./Tags.vue?vue&type=template&id=4b0ffe3d&", function () {
      api.rerender('4b0ffe3d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Tags.vue"
export default component.exports